<h1 class="mb-4 has-text-centered">{{ 'translations.language.title' | translate }}</h1>

<form [formGroup]="languageForm" (ngSubmit)="onSubmit()">
  @for (language of languages; track language) {
    <div class="control">
      <label class="radio mb-4">
        <input type="radio" name="language" value="{{ language.code }}" formControlName="language">
        {{ language.label | translate }}
      </label>
    </div>
  }

  <button type="submit" class="button is-primary mb-4 is-fullwidth">{{ "application.validate" | translate }}</button>
</form>
